import { scoreConfluence, scoreExhaustion } from "./lib/score"

export default function TabPremium({
  InfoTip,
  applyPromoCode,
  etfEnriched,
  fetchTechnical,
  handleSubscribe,
  isPremium,
  loadingTech,
  manageSubscription,
  promoCode,
  promoError,
  s,
  setPromoCode,
  setTechTicker,
  setTechnical,
  setTxtTech,
  techTicker,
  technical,
  txtTech,
}) {
  return (
        <div>
          {!isPremium ? (
            <div style={{...s.card, textAlign:"center", padding:24, background:"linear-gradient(135deg, #1e1b4b, #312e81)"}}>
              <div style={{fontSize:48, marginBottom:8}}>⭐</div>
              <h2 style={{color:"#a5b4fc", fontSize:22, fontWeight:"bold", margin:"0 0 8px 0"}}>ClawETF Premium</h2>
              <p style={{color:"#c7d2fe", fontSize:13, marginBottom:20, lineHeight:1.6}}>Análise técnica profissional com indicadores avançados.</p>
              {["🎯 CLAW Confluence Score™ — score técnico agregado","🔋 CLAW Exhaustion Score™ — detecta exaustão do movimento","📊 RSI — Índice de Força Relativa","📉 Bollinger Bands","📈 MACD — Momentum","🎯 Suporte e Resistência","🤖 Análise Claude ilimitada","💠 CLAW AI com contexto completo do portfólio","🧮 Resumo técnico por tempo gráfico — 12 indicadores e 12 médias em 5 prazos, com veredito","🔍 Integridade da base — preço conferido em duas fontes independentes antes de qualquer conta","📐 Fibonacci de 90 dias e pontos de pivô — sete níveis e os suportes e resistências calculados","☁️ Ichimoku Cloud e 🚀 Supertrend — tendência por nuvem e por nível, além do MACD","📈 Médias móveis EMA 9/21/50 e SMA 50 — com veredito de tendência","📅 Range de 52 semanas e ATR% — posição no ano e oscilação diária","🔎 Qualquer ticker, não só a sua carteira — ações e ETFs que você ainda nem comprou"].map((f,i) => (
                <div key={i} style={{display:"flex", alignItems:"center", gap:8, marginBottom:8, textAlign:"left"}}>
                  <span style={{color:"#22c55e"}}>✓</span>
                  <span style={{color:"#e0e7ff", fontSize:13}}>{f}</span>
                </div>
              ))}
              <p style={{color:"#9ca3af", fontSize:11, lineHeight:1.5, margin:"0 0 4px 0", textAlign:"left"}}>Cada score desta aba é registrado e conferido trinta dias depois — e o resultado fica no app, inclusive quando é ruim.</p>
              <div style={{margin:"20px 0 16px"}}>
                <span style={{color:"#a5b4fc", fontSize:28, fontWeight:"bold"}}>$9,99</span>
                <span style={{color:"#818cf8", fontSize:14}}>/mês</span>
              </div>
              <div style={{marginBottom:16, borderTop:"1px solid #1f2937", paddingTop:16}}>
                <p style={{color:"#9ca3af", fontSize:12, marginBottom:8}}>🎟️ Tem um código de acesso?</p>
                <div style={{display:"flex", gap:8}}>
                  <input value={promoCode} onChange={e => setPromoCode(e.target.value)} placeholder="Digite o código" style={{...s.input, marginBottom:0, flex:1}} />
                  <button onClick={applyPromoCode} style={{...s.addBtn, width:"auto", padding:"0 16px", fontSize:13}}>Aplicar</button>
                </div>
                {promoError && <p style={{color:"#ef4444", fontSize:11, margin:"4px 0 0 0"}}>{promoError}</p>}
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={() => handleSubscribe("USD")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #6366f1, #8b5cf6)", fontSize:13}}>
                  💳 $9,99/mês
                </button>
                <button onClick={() => handleSubscribe("BRL")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #059669, #0891b2)", fontSize:13}}>
                  💳 R$49,90/mês
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div style={{...s.card, background:"linear-gradient(135deg, #1e1b4b, #312e81)"}}>
                <p style={{color:"#a5b4fc", fontSize:12, margin:"0 0 8px 0"}}>⭐ Premium Ativo</p>
                <button onClick={manageSubscription} style={{...s.addBtn, backgroundColor:"#1f2937", marginBottom:8, fontSize:13}}>⚙️ Gerenciar Assinatura</button>
                <select value={etfEnriched.some(x => x.symbol === techTicker) ? techTicker : ""} onChange={e => { if(e.target.value) { setTechTicker(e.target.value); setTxtTech(""); setTechnical({}) } }} style={{...s.input, marginBottom:6}}>
                  <option value="">Da minha carteira...</option>
                  {etfEnriched.map(x => <option key={x.symbol} value={x.symbol}>{x.symbol}</option>)}
                </select>
                <div style={{fontSize:11, color:"#64748b", textAlign:"center", marginBottom:6}}>— ou —</div>
                <input value={txtTech} onChange={e => { const _v = e.target.value.toUpperCase().trim(); setTxtTech(_v); setTechTicker(_v); setTechnical({}) }} placeholder="Digite o ticker (ex: DRI, AAPL, VOO...)" style={{...s.input, marginBottom:0}} />
                <button onClick={() => fetchTechnical(techTicker)} style={s.addBtn}>
                  {loadingTech ? "Carregando..." : "📊 Analisar " + techTicker}
                </button>
              </div>
              {technical.rsi && (
                <div>
                  <div style={s.row}>
                    <div style={{...s.card, flex:1, textAlign:"center"}}>
                      <p style={s.label}>RSI (14)<InfoTip id="rsi"/></p>
                      <p style={{...s.bigNum, color: technical.rsi < 30 ? "#22c55e" : technical.rsi > 70 ? "#ef4444" : "#f59e0b"}}>{technical.rsi}</p>
                      <span style={{...s.badge, backgroundColor:"#1f2937", color: technical.rsi < 30 ? "#22c55e" : technical.rsi > 70 ? "#ef4444" : "#f59e0b"}}>
                        {technical.rsi_signal === "oversold" ? "Sobrevendido" : technical.rsi_signal === "overbought" ? "Sobrecomprado" : "Neutro"}
                      </span>
                    </div>
                    <div style={{...s.card, flex:1, textAlign:"center"}}>
                      <p style={s.label}>MACD Hist<InfoTip id="macd"/></p>
                      <p style={{...s.bigNum, color: technical.macd?.histogram > 0 ? "#22c55e" : "#ef4444"}}>{technical.macd?.histogram?.toFixed(3)}</p>
                      <span style={{...s.badge, backgroundColor:"#1f2937", color: technical.macd?.signal_label === "bullish" ? "#22c55e" : "#ef4444"}}>
                        {technical.macd?.signal_label === "bullish" ? "Alta" : "Baixa"}
                      </span>
                    </div>
                  </div>
                  <div style={s.card}>
                    <p style={s.cardTitle}>📉 Bollinger Bands<InfoTip id="bollinger"/></p>
                    <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                      <span style={{color:"#ef4444", fontSize:12}}>Inf: ${technical.bollinger?.lower?.toFixed(2)}</span>
                      <span style={{color:"#9ca3af", fontSize:12}}>Med: ${technical.bollinger?.middle?.toFixed(2)}</span>
                      <span style={{color:"#22c55e", fontSize:12}}>Sup: ${technical.bollinger?.upper?.toFixed(2)}</span>
                    </div>
                    <div style={{height:8, backgroundColor:"#1f2937", borderRadius:4, position:"relative"}}>
                      <div style={{position:"absolute", left:0, top:0, height:"100%", borderRadius:4, width: Math.min(100, Math.max(0, ((technical.current_price - technical.bollinger?.lower) / (technical.bollinger?.upper - technical.bollinger?.lower)) * 100)) + "%", background:"linear-gradient(90deg, #ef4444, #f59e0b, #22c55e)"}}/>
                    </div>
                    <p style={{color:"#9ca3af", fontSize:11, marginTop:4, textAlign:"center"}}>
                      ${technical.current_price} — {technical.bollinger?.signal === "oversold" ? "Sobrevendido" : technical.bollinger?.signal === "overbought" ? "Sobrecomprado" : "Dentro das bandas"}
                    </p>
                  </div>
                  <div style={s.card}>
                    <p style={s.cardTitle}>🎯 Suporte e Resistência</p>
                    <div style={{display:"flex", justifyContent:"space-between"}}>
                      <div style={{textAlign:"center"}}>
                        <p style={s.label}>Suporte</p>
                        <p style={{...s.bigNum, color:"#22c55e", fontSize:16}}>${technical.support_resistance?.support?.toFixed(2)}</p>
                      </div>
                      <div style={{textAlign:"center"}}>
                        <p style={s.label}>Atual</p>
                        <p style={{...s.bigNum, fontSize:16}}>${technical.current_price?.toFixed(2)}</p>
                      </div>
                      <div style={{textAlign:"center"}}>
                        <p style={s.label}>Resistência</p>
                        <p style={{...s.bigNum, color:"#ef4444", fontSize:16}}>${technical.support_resistance?.resistance?.toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                  {technical?.week52 && (
                    <div style={s.card}>
                      <p style={s.cardTitle}>📅 52-Week Range</p>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <div style={{textAlign:"center"}}>
                          <p style={{color:"#6b7280", fontSize:11, margin:"0 0 2px 0"}}>Mínima anual</p>
                          <p style={{color:"#22c55e", fontSize:14, fontWeight:"bold", margin:0}}>${technical.week52.low?.toFixed(2)}</p>
                          <p style={{color:"#22c55e", fontSize:10, margin:0}}>+{technical.week52.dist_from_low?.toFixed(1)}%</p>
                        </div>
                        <div style={{textAlign:"center"}}>
                          <p style={{color:"#6b7280", fontSize:11, margin:"0 0 2px 0"}}>Atual</p>
                          <p style={{fontSize:14, fontWeight:"bold", margin:0, color:"#e2e8f0"}}>${technical.current_price?.toFixed(2)}</p>
                        </div>
                        <div style={{textAlign:"center"}}>
                          <p style={{color:"#6b7280", fontSize:11, margin:"0 0 2px 0"}}>Máxima anual</p>
                          <p style={{color:"#ef4444", fontSize:14, fontWeight:"bold", margin:0}}>${technical.week52.high?.toFixed(2)}</p>
                          <p style={{color:"#ef4444", fontSize:10, margin:0}}>{technical.week52.dist_from_high?.toFixed(1)}%</p>
                        </div>
                      </div>
                      <div style={{marginTop:8, padding:"6px 10px", backgroundColor:"#0f172a", borderRadius:6}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>ATR% (volatilidade diária): </span>
                        <span style={{color: technical.atr_pct > 3 ? "#ef4444" : technical.atr_pct > 1.5 ? "#f59e0b" : "#22c55e", fontSize:11, fontWeight:"bold"}}>{technical.atr_pct?.toFixed(2)}%</span>
                      </div>
                    </div>
                  )}
                  {technical?.fibonacci && (
                    <div style={s.card}>
                      <p style={s.cardTitle}>📐 Fibonacci Retracement (90 dias)<InfoTip id="fibonacci"/></p>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Máximo: <span style={{color:"#22c55e"}}>${technical.fibonacci.high?.toFixed(2)}</span></span>
                        <span style={{color:"#9ca3af", fontSize:11}}>Mínimo: <span style={{color:"#ef4444"}}>${technical.fibonacci.low?.toFixed(2)}</span></span>
                      </div>
                      {(() => {
                        const cp = technical.current_price || 0
                        const nv = Object.entries(technical.fibonacci.levels||{})
                          .map(([k,v]) => [parseFloat(k), parseFloat(v)])
                          .sort((a,b) => a[0]-b[0])
                        if (!cp || nv.length === 0) return null
                        const acima = nv.filter(x => x[1] >= cp).sort((a,b) => a[1]-b[1])[0]
                        const abaixo = nv.filter(x => x[1] < cp).sort((a,b) => b[1]-a[1])[0]
                        const d = (alvo) => ((cp - alvo) / alvo * 100)
                        return (
                          <div style={{backgroundColor:"#0f172a", borderRadius:8, padding:"8px 10px", marginBottom:8}}>
                            <p style={{color:"#e2e8f0", fontSize:12, fontWeight:700, margin:"0 0 4px 0"}}>Atual: ${cp.toFixed(2)}</p>
                            {acima && <p style={{color:"#9ca3af", fontSize:11, margin:"0 0 2px 0"}}>{Math.abs(d(acima[1])).toFixed(1)}% abaixo do {acima[0]}% (${acima[1].toFixed(2)})</p>}
                            {abaixo && <p style={{color:"#9ca3af", fontSize:11, margin:0}}>{d(abaixo[1]).toFixed(1)}% acima do {abaixo[0]}% (${abaixo[1].toFixed(2)})</p>}
                          </div>
                        )
                      })()}
                      {Object.entries(technical.fibonacci.levels||{}).sort((a,b)=>parseFloat(a[0])-parseFloat(b[0])).map(([pct, val]) => {
                        const cp = technical.current_price || 0
                        const isNear = Math.abs(cp - val) / cp < 0.02
                        return (
                          <div key={pct} style={{display:"flex", justifyContent:"space-between", padding:"3px 0", borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                            <span style={{color: isNear ? "#f59e0b" : "#6b7280", fontSize:11, fontWeight: isNear ? "bold" : "normal"}}>{pct}%</span>
                            <span style={{color: isNear ? "#f59e0b" : "#e2e8f0", fontSize:11, fontWeight: isNear ? "bold" : "normal"}}>${val?.toFixed(2)} {isNear ? (cp < val ? "← preço " + ((val-cp)/cp*100).toFixed(1) + "% abaixo" : "← preço " + ((cp-val)/cp*100).toFixed(1) + "% acima") : ""}</span>
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {technical?.ema && (
                    <div style={s.card}>
                      <p style={s.cardTitle}>📈 Médias Móveis<InfoTip id="ema"/></p>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Tendência</span>
                        <span style={{fontWeight:"bold", fontSize:13, color: technical.ema.trend === "bullish" ? "#22c55e" : technical.ema.trend === "bearish" ? "#ef4444" : "#f59e0b"}}>
                          {technical.ema.trend === "bullish" ? "Alta ▲" : technical.ema.trend === "bearish" ? "Baixa ▼" : "Neutro —"}
                        </span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6, paddingBottom:4, borderBottom:"1px solid #1f2937"}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Atual</span>
                        <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>${technical.current_price?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>EMA 9</span>
                        <span style={{color: technical.current_price > technical.ema.ema9 ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.ema.ema9?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>EMA 21</span>
                        <span style={{color: technical.current_price > technical.ema.ema21 ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.ema.ema21?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>EMA 50</span>
                        <span style={{color: technical.current_price > technical.ema.ema50 ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.ema.ema50?.toFixed(2)}</span>
                      </div>
                      {technical.ema.ema200 && (
                        <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                          <span style={{color:"#9ca3af", fontSize:11}}>EMA 200</span>
                          <span style={{color: technical.current_price > technical.ema.ema200 ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.ema.ema200?.toFixed(2)}</span>
                        </div>
                      )}
                      {technical.ema.sma50 && (
                        <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                          <span style={{color:"#9ca3af", fontSize:11}}>SMA 50</span>
                          <span style={{color: technical.current_price > technical.ema.sma50 ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.ema.sma50?.toFixed(2)}</span>
                        </div>
                      )}
                      <p style={{color:"#4b5563", fontSize:10, marginTop:4}}>Verde = preço acima · Vermelho = preço abaixo</p>
                    </div>
                  )}
                  {technical?.supertrend && (
                    <div style={s.card}>
                      <p style={s.cardTitle}>🚀 Supertrend<InfoTip id="supertrend"/></p>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Sinal</span>
                        <span style={{fontWeight:"bold", fontSize:13, color: technical.supertrend.signal === "bullish" ? "#22c55e" : "#ef4444"}}>
                          {technical.supertrend.signal === "bullish" ? "Alta ▲" : "Baixa ▼"}
                        </span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6, paddingBottom:4, borderBottom:"1px solid #1f2937"}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Atual</span>
                        <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>${technical.current_price?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between"}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Nível</span>
                        <span style={{color: technical.supertrend.signal === "bullish" ? "#22c55e" : "#ef4444", fontSize:11}}>${technical.supertrend.value?.toFixed(2)}</span>
                      </div>
                      <p style={{color:"#4b5563", fontSize:10, marginTop:4}}>O Supertrend permanece em Alta enquanto o preço atual estiver acima do Nível, e passa para Baixa quando ficar abaixo.</p>
                    </div>
                  )}
                  {technical.ichimoku && (
                    <div style={s.card}>
                      <p style={s.cardTitle}>☁️ Ichimoku Cloud<InfoTip id="ichimoku"/></p>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Sinal</span>
                        <span style={{fontWeight:"bold", fontSize:13, color: (technical.ichimoku.senkou_a == null || technical.ichimoku.senkou_b == null) ? "#6b7280" : technical.ichimoku.signal === "bullish" ? "#22c55e" : technical.ichimoku.signal === "bearish" ? "#ef4444" : "#f59e0b"}}>
                          {/* sem nuvem calculada, "neutro" seria enganoso: o indicador nao pode ser medido */}
                          {(technical.ichimoku.senkou_a == null || technical.ichimoku.senkou_b == null) ? "sem dados" : technical.ichimoku.signal === "bullish" ? "Alta ▲" : technical.ichimoku.signal === "bearish" ? "Baixa ▼" : "Neutro —"}
                        </span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:6, paddingBottom:4, borderBottom:"1px solid #1f2937"}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Atual</span>
                        <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>${technical.current_price?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Tenkan-sen (9)</span>
                        <span style={{color:"#e2e8f0", fontSize:11}}>${technical.ichimoku.tenkan?.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                        <span style={{color:"#9ca3af", fontSize:11}}>Kijun-sen (26)</span>
                        <span style={{color:"#e2e8f0", fontSize:11}}>${technical.ichimoku.kijun?.toFixed(2)}</span>
                      </div>
                      {/* Topo e Base seguem QUEM E MAIOR, nao o Span fixo: em tendencia de baixa
                          o Span A cruza para baixo do Span B, e o rotulo fixo mentia */}
                      {(() => {
                        const _a = technical.ichimoku.senkou_a, _b = technical.ichimoku.senkou_b
                        if (_a == null || _b == null) return (
                          <>
                            <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                              <span style={{color:"#9ca3af", fontSize:11}}>Nuvem (Span A)</span>
                              <span style={{color:"#6b7280", fontSize:11}}>{_a != null ? "$" + _a.toFixed(2) : "sem dados"}</span>
                            </div>
                            <div style={{display:"flex", justifyContent:"space-between"}}>
                              <span style={{color:"#9ca3af", fontSize:11}}>Nuvem (Span B)</span>
                              <span style={{color:"#6b7280", fontSize:11}}>{_b != null ? "$" + _b.toFixed(2) : "sem dados"}</span>
                            </div>
                          </>
                        )
                        const topo = _a >= _b ? {v:_a, n:"A"} : {v:_b, n:"B"}
                        const base = _a >= _b ? {v:_b, n:"B"} : {v:_a, n:"A"}
                        return (
                          <>
                            <div style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                              <span style={{color:"#9ca3af", fontSize:11}}>Nuvem Topo (Span {topo.n})</span>
                              <span style={{color:"#22c55e", fontSize:11}}>${topo.v.toFixed(2)}</span>
                            </div>
                            <div style={{display:"flex", justifyContent:"space-between"}}>
                              <span style={{color:"#9ca3af", fontSize:11}}>Nuvem Base (Span {base.n})</span>
                              <span style={{color:"#ef4444", fontSize:11}}>${base.v.toFixed(2)}</span>
                            </div>
                          </>
                        )
                      })()}
                    </div>
                  )}
                </div>
              )}

              {(() => {
                const cs = scoreConfluence(technical)
                const abs = cs.abs
                const dir = cs.dir
                const label = cs.label
                const color=abs>=80?(dir==='bearish'?'#ef4444':'#22c55e'):abs>=60?(dir==='bearish'?'#f97316':'#86efac'):abs>=40?(dir==='bearish'?'#f59e0b':'#f59e0b'):'#64748b'
                return (
                  <div style={{...s.card, marginTop:12}}>
                    <p style={s.cardTitle}>🎯 CLAW Confluence Score™</p>
                    <p style={{color:"#6b7280", fontSize:10, margin:"0 0 8px 0", lineHeight:1.5}}>Diferença entre os sinais de alta e os de baixa. Perto de 0 = sinais empatados, não "ativo ruim". Quanto maior, mais forte a direção indicada abaixo.</p>
                    <div style={{textAlign:'center',marginBottom:12}}>
                      <div style={{fontSize:36,fontWeight:'bold',color}}>{abs}/100</div>
                      <div style={{fontSize:13,color,marginTop:4}}>{abs>=80?(dir==='bearish'?'🔴':'🟢'):abs>=60?(dir==='bearish'?'🟠':'🟢'):abs>=40?(dir==='bearish'?'🟡':'🟡'):'⚪'} {label}</div>
                    </div>
                    <div style={{borderTop:'1px solid #1e293b',paddingTop:8}}>
                      {cs.signals.map((sig,i)=>(
                        <div key={i} style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                          <span style={{color:'#9ca3af',fontSize:11}}>{sig.i}</span>
                          <span style={{fontSize:11,color:sig.s==='bearish'?'#ef4444':'#22c55e'}}>{sig.v} {sig.s==='bearish'?'▼':'▲'}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              })()}

              {technical && technical.rsi && (() => {
                // Exhaustion Score — measures how exhausted the current move is
                const rsi = technical.rsi
                const bb = technical.bollinger
                const macd = technical.macd

                const _ex = scoreExhaustion(technical)
                const exScore = _ex.score
                const exDet = _ex.detalhes
                const exLabel = _ex.label
                const bounceProb = _ex.bounce
                const bounceColor = exScore >= 80 ? '#ef4444' : exScore >= 60 ? '#f97316' : exScore >= 40 ? '#f59e0b' : '#94a3b8'

                return (
                  <div style={{...s.card, marginTop:12}}>
                    <p style={s.cardTitle}>🔋 CLAW Exhaustion Score™</p>
                    <p style={{color:"#6b7280", fontSize:10, margin:"0 0 8px 0", lineHeight:1.5}}>Mede se o movimento atual está esticado e perto de reverter — não se o ativo é bom ou ruim. Score alto: o movimento está esticado e pode virar. Score baixo: não há sinal de reversão à vista, em qualquer direção.</p>
                    <div style={{textAlign:'center', marginBottom:12}}>
                      <div style={{fontSize:36, fontWeight:'bold', color:bounceColor}}>{exScore}/100</div>
                      <div style={{fontSize:13, color:bounceColor, marginTop:4}}>{exLabel}</div>
                    </div>
                    <div style={{borderTop:'1px solid #1e293b', paddingTop:8}}>
                      <div style={{display:'flex', justifyContent:'space-between', marginBottom:6}}>
                        <span style={{color:'#9ca3af', fontSize:11}}>Prob. Reversão</span>
                        <span style={{fontSize:11, fontWeight:'bold', color:bounceColor}}>{bounceProb}</span>
                      </div>
                      <div style={{display:'flex', justifyContent:'space-between', marginBottom:4}}>
                        <span style={{color:'#9ca3af', fontSize:11}}>RSI</span>
                        <span style={{fontSize:11, color: rsi < 30 ? '#ef4444' : rsi > 70 ? '#f97316' : '#9ca3af'}}>{rsi?.toFixed(1)} {rsi < 30 ? '⚠️ sobrevendido' : rsi > 70 ? '⚠️ sobrecomprado' : '—'}</span>
                      </div>
                      <div style={{display:'flex', justifyContent:'space-between', marginBottom:4}}>
                        <span style={{color:'#9ca3af', fontSize:11}}>Bollinger</span>
                        <span style={{fontSize:11, color:'#9ca3af'}}>{({neutral:'dentro das bandas', overbought:'sobrecomprado', oversold:'sobrevendido'})[bb?.signal] || bb?.signal || '—'}</span>
                      </div>
                      <div style={{display:'flex', justifyContent:'space-between', marginBottom:4}}>
                        <span style={{color:'#9ca3af', fontSize:11}}>MACD Histograma</span>
                        <span style={{fontSize:11, color:'#9ca3af'}}>{macd?.histogram?.toFixed(3) || '—'}</span>
                      </div>
                      <div style={{borderTop:'1px solid #1e293b', marginTop:8, paddingTop:8}}>
                        <p style={{color:'#6b7280', fontSize:10, margin:'0 0 6px 0'}}>De onde vem o score</p>
                        {exDet.map((d,i) => (
                          <div key={i} style={{display:'flex', justifyContent:'space-between', marginBottom:3}}>
                            <span style={{color: d.pts > 0 ? '#e2e8f0' : '#4b5563', fontSize:10}}>{d.n} · {d.nota}</span>
                            <span style={{color: d.pts > 0 ? '#f59e0b' : '#4b5563', fontSize:10, fontWeight: d.pts > 0 ? 'bold' : 'normal'}}>+{d.pts}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )
              })()}

            </div>
          )}
        </div>
  )
}
